enum HostedUrlType {
  beneficialOwner = 'bo',
  onboardingConfigPublicKey = 'ob_pk',
  user = 'user',
}

export default HostedUrlType;
